import { Component, ElementRef, ViewChild } from "@angular/core";
import { equalParamsAndUrlSegments } from "@angular/router/src/router_state";
import { IAfterGuiAttachedParams, ICellEditorParams } from "ag-grid";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { DropDownItem } from "app/components/tx-ui-inner-3/dropdown/dropdown.item";

declare var $:any;


@Component({
  selector: 'ag-dropdown-editor',
  template:
`
<div class="ag-dropdown-editor">
	<ul>
		<li *ngFor="let item of items" class="ag-dropdown-item">
			{{getText(item)}}			
		</li>
	</ul>
</div>
`
})
export class AgDropdownEditor implements ICellEditorAngularComp {
	
	params: ICellEditorParams;
	items: DropDownItem<any>[];
	selected: DropDownItem<any>;
	isChange: boolean = false;


	getText(item: DropDownItem<any>): String {
		if (item && item.value !== null && typeof item.value !== 'undefined') {
			return item.text;
		} else {
			return '';
		}
	}

	agInit(params: ICellEditorParams): void {
		this.params = params;
		this.items = this.params['items'];
	}


	getValue() {
		console.log('getValue');
		// return this.datePickerInput.nativeElement.value;
	}
	
	
	isCancelAfterEnd?(): boolean {
		return true;
		// return !this.isChange && !this.datePickerInput.nativeElement.value;
	}

	
	afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
		console.log('afterGuiAttached', params);
		
		// this.selectElement.nativeElement.focus();
		// $(this.selectElement.nativeElement).click();
	}


	// onKeyDown(event: KeyboardEvent) {
	// 	// 방향키
	// 	if (event.keyCode >= 37 && event.keyCode <= 40) this.datePicker.datepicker('hide');
	// }


	isPopup?(): boolean {
		return false;
	}

	isCancelBeforeStart?(): boolean {
		return false;
	}



}




// WEBPACK FOOTER //
// ./src/app/components/ag-grid/editor/ag-dropdown.editor.ts